import script from "./StandardsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardsPage.vue?vue&type=script&setup=true&lang=js"

import "@/styles/console.css?vue&type=style&index=0&lang=css&external"
import "@/styles/tool-page.css?vue&type=style&index=1&lang=css&external"

const __exports__ = script;

export default __exports__